export default __webpack_public_path__ + "static/media/Team spirit-pana.2de39cd3.svg";